import styled from 'styled-components';
import { rem } from 'polished';
var Square = styled.div.withConfig({
  displayName: "Squarestyles__Square",
  componentId: "sc-mkpnug-0"
})(["display:inline-flex;align-items:center;justify-content:center;position:relative;border-radius:", ";width:", ";height:", ";color:", ";background-color:", ";&:before{content:'';position:absolute;border-radius:", ";top:0;left:0;width:", ";height:", ";border:", ";}"], function (props) {
  return rem(props.borderRadius);
}, function (props) {
  return rem(props.size);
}, function (props) {
  return rem(props.size);
}, function (props) {
  return props.color;
}, function (props) {
  return props.bgColor;
}, function (props) {
  return rem(props.borderRadius);
}, function (props) {
  return rem(props.size);
}, function (props) {
  return rem(props.size);
}, function (props) {
  return "".concat(rem(props.borderSize), " ").concat(props.borderStyle, " ").concat(props.borderColor);
});
export var Styled = {
  Square: Square
};